import React, { useRef } from 'react';
import { X as CloseButton } from 'react-feather';
import CommentList from 'components/comment/CommentList';
import PostCommentForm from 'components/comment/PostCommentForm';
import { useGetPaginationByType } from 'entity/comment/commentHooks';
import useClickOutside from 'app/utils/hooks/useClickOutside';
import { generateOpinionLink } from 'utils/generateShareLink';

import {
  BackgroundContainer,
  CommentContainer,
  OverlayHeader,
  OverlayBody,
} from './styles';

interface OwnProps {
  isCommentOpen: boolean;
  handleCommentClose: () => void;
  opinion: any;
}

const OpinionCommentOverlay = ({
  isCommentOpen,
  handleCommentClose,
  opinion,
}: OwnProps) => {
  const { id } = opinion;
  const opinionPagination = useGetPaginationByType('Opinion', opinion.id);
  const { pagination } = opinionPagination;

  const commentWrapper = useRef(null);
  useClickOutside(commentWrapper, handleCommentClose);

  return (
    <BackgroundContainer isCommentOpen={isCommentOpen}>
      <CommentContainer ref={commentWrapper} isCommentOpen={isCommentOpen}>
        <OverlayHeader justifyContent="space-between" width="100%">
          <div className="text-xl font-bold">
            <span role="img" aria-label="comments">
              💬
            </span>{' '}
            Comments ({pagination.totalCount})
          </div>
          <CloseButton
            onClick={handleCommentClose}
            style={{ cursor: 'pointer' }}
          />
        </OverlayHeader>
        <OverlayBody
          width="100%"
          direction="column"
          hasComments={pagination.totalCount > 0}
        >
          <PostCommentForm commentableType="Opinion" commentableId={id} />
          <div className="horizontal-divider" />
          {pagination.totalCount > 0 ? (
            <CommentList
              totalCommentCount={opinion.commentsCount}
              commentableId={id}
              commentableType="Opinion"
              childCommentableType="OpinionComment"
              commentShareLink={generateOpinionLink(opinion.slug)}
            />
          ) : (
            <div className="flex flex-col gap-4 h-full justify-center items-center">
              <p className="text-neutral-500 text-center">
                No comments yet. <br /> Be the first to share your thoughts!
              </p>
            </div>
          )}
        </OverlayBody>
      </CommentContainer>
    </BackgroundContainer>
  );
};

export default OpinionCommentOverlay;
